import React from "react";
import { render } from "react-dom";
import AppWrapper from "./components/Context/";
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "@apollo/react-hooks";

// GraphQL client.
const client = new ApolloClient({
  uri: `${window.location.origin}${drupalSettings.path.baseUrl}graphql`,
});

const Index = () => {
  return (
    <ApolloProvider client={client}>
      <AppWrapper />
    </ApolloProvider>
  );
};
render(<Index />, document.getElementById("location-app"));
